import React from 'react';
import type { OrganizationMember } from '@/types/user';

interface MemberMenuOptionsProps {
  member: OrganizationMember;
  onEditName: (member: OrganizationMember) => void;
  onRemoveMember: (member: OrganizationMember) => void;
  onActionComplete?: () => void;
  MenuItem: React.ElementType;
  MenuSeparator: React.ElementType;
}

export function MemberMenuOptions({
  member,
  onEditName,
  onRemoveMember,
  onActionComplete,
  MenuItem,
  MenuSeparator,
}: MemberMenuOptionsProps) {
  const handleEditName = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEditName(member);
    onActionComplete?.();
  };

  const handleRemoveMember = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemoveMember(member);
    onActionComplete?.();
  };

  return (
    <>
      <MenuItem onClick={handleEditName}>Edit name</MenuItem>
      <MenuSeparator />
      <MenuItem
        onClick={handleRemoveMember}
        className="text-destructive focus:text-destructive"
      >
        Remove member
      </MenuItem>
    </>
  );
}
